module.exports = __webpack_public_path__ + "img/title_leveltest.4fe20005.png";